import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  query: '',
  results: [],
  isSearching: false,
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setQuery: (state, action) => {
      state.query = action.payload;
    },
    setSearchResults: (state, action) => {
      state.results = action.payload;
    },
    setIsSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    clearResults: (state) => {
      state.results = [];
    },
    clearSearch: (state) => {
      state.query = '';
      state.results = [];
      state.isSearching = false;
    },
  },
});

export const { setQuery, setSearchResults, setIsSearching, clearResults, clearSearch } = searchSlice.actions;
export default searchSlice.reducer;
